import { render } from "./CookieConsent.vue?vue&type=template&id=728a00a0&scoped=true&ts=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=728a00a0&scoped=true&lang=css"

import exportComponent from "/data/front/cryptogold-front-new-domain/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728a00a0"]])

export default __exports__